function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "4BA30C8D-CEA6-438C-BB44-D06B74ABC59E");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Desktop-png",
  transform: "translate(-1195.000000, -96.000000)",
  fill: "#C4C4C4",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "twitter-logo-button",
  transform: "translate(1195.000000, 96.000000)"
}, React.createElement("path", {
  d: "M9.20428424,0 C4.12906282,0 0,4.12906282 0,9.20428424 C0,14.2791349 4.12906282,18.4085685 9.20428424,18.4085685 C14.2791349,18.4085685 18.4085685,14.2791349 18.4085685,9.20428424 C18.4085685,4.12906282 14.2798764,0 9.20428424,0 Z M13.3103605,7.0976725 C13.3144387,7.18887745 13.3166632,7.28082389 13.3166632,7.37277034 C13.3166632,10.1723172 11.1863234,13.3993409 7.28860968,13.3993409 C6.09219361,13.3993409 4.9784552,13.0497219 4.04119464,12.4483625 C4.2069207,12.4680124 4.37561277,12.4780227 4.54652935,12.4780227 C5.53940268,12.4780227 6.45256437,12.1391555 7.17775489,11.5711637 C6.25087539,11.5541092 5.46821833,10.9416272 5.19868177,10.0996498 C5.3277034,10.1241195 5.4608033,10.1378373 5.59686921,10.1378373 C5.7900309,10.1378373 5.97763131,10.1126262 6.15522142,10.0640577 C5.18607621,9.86978373 4.45606591,9.01371782 4.45606591,7.98673532 C4.45606591,7.97783728 4.45606591,7.96856849 4.45643666,7.96004119 C4.74191555,8.11835221 5.06854789,8.21400618 5.41557158,8.22475798 C4.84757981,7.84547889 4.47349125,7.19666323 4.47349125,6.46183316 C4.47349125,6.07328527 4.5776725,5.709207 4.76008239,5.39629248 C5.80449022,6.67835221 7.36609681,7.52144181 9.12642636,7.61042225 C9.09009269,7.45507724 9.07192585,7.29380021 9.07192585,7.12733265 C9.07192585,5.95761071 10.020309,5.00885685 11.1900309,5.00885685 C11.7995469,5.00885685 12.3493718,5.2661586 12.7364367,5.6776931 C13.2195263,5.58278064 13.6718435,5.40704428 14.0822657,5.16346035 C13.9228424,5.65841401 13.5880536,6.07328527 13.1494542,6.33577755 C13.578414,6.2846138 13.987724,6.17116375 14.3662616,6.00247168 C14.0837487,6.42661174 13.7244902,6.79995881 13.3103605,7.0976725 Z",
  id: "Shape"
}))));

var SvgTwitterLogoButton = function SvgTwitterLogoButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitterLogoButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter-logo-button.d5f32fae.svg";
export { ForwardRef as ReactComponent };